import { PaletteOptions } from '@mui/material';
import colors from './colors';

/**
 * 주담 브랜드 테마 팔레트 (Design Tokens 1.0)
 */
const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: colors.primary.main,
    light: colors.primary.light,
    dark: colors.primary.dark,
    contrastText: colors.primary.contrastText,
  },
  secondary: {
    main: colors.copper.main,
    light: colors.copper.light,
    dark: colors.copper.dark,
    contrastText: colors.copper.contrastText,
  },
  error: {
    main: colors.error.main,
    light: colors.error.light,
    dark: colors.error.dark,
    contrastText: colors.error.contrastText,
  },
  success: {
    main: colors.success.main,
    light: colors.success.light,
    dark: colors.success.dark,
    contrastText: colors.success.contrastText,
  },
  warning: {
    main: colors.warning.main,
    light: colors.warning.light,
    dark: colors.warning.dark,
    contrastText: colors.warning.contrastText,
  },
  info: {
    main: colors.info.main,
    light: colors.info.light,
    dark: colors.info.dark,
    contrastText: colors.info.contrastText,
  },
  text: {
    primary: colors.text.primary,
    secondary: colors.text.secondary,
    disabled: colors.text.disabled,
  },
  background: {
    default: colors.background.default,
    paper: colors.background.paper,
  },
  grey: colors.grey,
  divider: colors.divider,
  common: colors.common,
};

export default palette;
